import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
    GET_MDS_ASSESSMENT_RANGE_REQUEST,
    GET_MDS_ASSESSMENT_RANGE_SUCCESS,
    GET_MDS_ASSESSMENT_RANGE_FAILURE,
    GET_MDS_ASSESSMENT_RANGE_LOADING,
    GET_MDS_ASSESSMENT_RANGE_RESET,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  getMdsAssessment: false,
};

export const getMdsAssessmentRangeReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_MDS_ASSESSMENT_RANGE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        getMdsAssessment: true,
      };
    }

    case GET_MDS_ASSESSMENT_RANGE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        getMdsAssessment: false,
      };
    case GET_MDS_ASSESSMENT_RANGE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_MDS_ASSESSMENT_RANGE_RESET:
      return intitialstate;

    default:
      return state;
  }
};
